import { DefaultUser, IUser } from '../Definitions'
import { IUserDto } from '../generated_client'

function addDefaultUserFields(user: IUserDto): IUser {
  return { ...DefaultUser(), ...user }
}

export default addDefaultUserFields
